import { AxiosResponse } from 'axios';
import PhsPstRepo from './PhsPstRepo';
import { PstProgressCompleteRs } from '@domain/rs/phs/pst/result/PstProgressCompleteRs';
import { PstResultRs } from '@domain/rs/phs/pst/result/PstResultRs';

export default class PhsPstMock implements PhsPstRepo {
  // 개발자 능력 검사 결과
  async fetchPHSPSTResults(sn: number) {
    return {
      data: {
        level: 'BASIC',
        grade: 'BRONZE',
        version: 'V2',
        finalPassedStep: 3,
        lastSubmitResult: {
          priority: 8,
          score: 10,
          elapsedTime: 1,
          language: 'JAVASCRIPT',
          passedStep: 1,
          accuracy: 10,
          efficiency: 10,
        },
        resultHistories: [
          {
            priority: 0,
            score: 10,
            elapsedTime: 0,
            language: 'JAVASCRIPT',
            passedStep: 2,
            accuracy: 10,
            efficiency: 10,
          },
          {
            priority: 1,
            score: 0,
            elapsedTime: 0,
            language: 'JAVASCRIPT',
            passedStep: 3,
            accuracy: 10,
            efficiency: 10,
          },
          {
            priority: 2,
            score: 0,
            elapsedTime: 0,
            language: 'JAVASCRIPT',
            passedStep: 0,
            accuracy: 10,
            efficiency: 10,
          },
          {
            priority: 3,
            score: 0,
            elapsedTime: 0,
            language: 'JAVASCRIPT',
            passedStep: 0,
            accuracy: 10,
            efficiency: 10,
          },
          {
            priority: 4,
            score: 0,
            elapsedTime: 0,
            language: 'JAVASCRIPT',
            passedStep: 0,
            accuracy: 10,
            efficiency: 10,
          },
          {
            priority: 5,
            score: 0,
            elapsedTime: 0,
            language: 'JAVASCRIPT',
            passedStep: null,
            accuracy: 10,
            efficiency: 10,
          },
          {
            priority: 6,
            score: 0,
            elapsedTime: 1,
            language: 'JAVASCRIPT',
            passedStep: 0,
            accuracy: 10,
            efficiency: 10,
          },
          {
            priority: 7,
            score: 100,
            elapsedTime: 1,
            language: 'JAVASCRIPT',
            passedStep: 0,
            accuracy: 10,
            efficiency: 0,
          },
        ],
      },
    } as AxiosResponse<PstResultRs>;
  }

  // 이전 응시완료 결과 목록
  async fetchPHSPSTResultsProgressComplete() {
    return {
      data: {
        resultRecords: [
          {
            sn: 171,
            code: '62b693b8541042a8',
            analysisType: 'COMPLETED',
            grade: 'TRY_AGAIN',
            applyEndDateTime: '2022-04-02T17:46:00',
            matchingUseYn: false,
          },
          {
            sn: 172,
            code: '62b693b8541042a8',
            analysisType: 'COMPLETED',
            grade: 'BASIC_LOW',
            applyEndDateTime: '2022-04-02T17:46:00',
            matchingUseYn: false,
          },
          {
            sn: 173,
            code: '62b693b8541042a8',
            analysisType: 'COMPLETED',
            grade: 'BASIC_HIGH',
            applyEndDateTime: '2022-04-02T17:46:00',
            matchingUseYn: false,
          },
          {
            sn: 174,
            code: '62b693b8541042a8',
            analysisType: 'COMPLETED',
            grade: 'INTERMEDIATE_LOW',
            applyEndDateTime: '2022-04-02T17:46:00',
            matchingUseYn: false,
          },
          {
            sn: 175,
            code: '62b693b8541042a8',
            analysisType: 'COMPLETED',
            grade: 'INTERMEDIATE_MID',
            applyEndDateTime: '2022-04-02T17:46:00',
            matchingUseYn: false,
          },
          {
            sn: 176,
            code: '62b693b8541042a8',
            analysisType: 'COMPLETED',
            grade: 'INTERMEDIATE_HIGH',
            applyEndDateTime: '2022-04-02T17:46:00',
            matchingUseYn: false,
          },
          {
            sn: 177,
            code: '62b693b8541042a8',
            analysisType: 'COMPLETED',
            grade: 'ADVANCED_LOW',
            applyEndDateTime: '2022-04-02T17:46:00',
            matchingUseYn: false,
          },
          {
            sn: 178,
            code: '62b693b8541042a8',
            analysisType: 'COMPLETED',
            grade: 'ADVANCED_MID',
            applyEndDateTime: '2022-04-02T17:46:00',
            matchingUseYn: false,
          },
          {
            sn: 179,
            code: '62b693b8541042a8',
            analysisType: 'COMPLETED',
            grade: 'ADVANCED_HIGH',
            applyEndDateTime: '2022-04-02T17:46:00',
            matchingUseYn: false,
          },
        ],
      },
    } as AxiosResponse<PstProgressCompleteRs>;
  }

  // 매칭에 사용될 결과표 선택
  async fetchPHSPSTResultsSelectMatching(_applySn: number) {
    return {
      data: {},
    } as AxiosResponse;
  }
}
